import { render, staticRenderFns } from "./InfoLabel.vue?vue&type=template&id=6fccceca&scoped=true&"
import script from "./InfoLabel.vue?vue&type=script&lang=js&"
export * from "./InfoLabel.vue?vue&type=script&lang=js&"
import style0 from "./InfoLabel.vue?vue&type=style&index=0&id=6fccceca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fccceca",
  null
  
)

export default component.exports